import React from "react";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import styled from "styled-components/macro";
import banner from "../../../assets/images/Ivcp/325927_feat_img.jpg";
import img1 from "../../../assets/images/Ivcp/icon-reliability.png";
import img2 from "../../../assets/images/Ivcp/accuracy.png";
import img3 from "../../../assets/images/Ivcp/time.png";
import img4 from "../../../assets/images/Ivcp/convience.png";
import img5 from "../../../assets/images/Ivcp/enhanced.webp";
import img6 from "../../../assets/images/Ivcp/afford.png";
import img7 from "../../../assets/images/Ivcp/educ.png";
import img8 from "../../../assets/images/Ivcp/relation.webp";
import img9 from "../../../assets/images/Ivcp/community.png";
import img10 from "../../../assets/images/Ivcp/satisfaction.png";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";


const ivcp = [
  {
    id: 1,
    img: img1,
    title: "Reliability",
    desc: "One of the most important factors in picking a pharmacy is reliability. When weighing your options, ask yourself if you can depend on your pharmacy to do the job right, every single time.With national chains, who often face problems from being understaffed and having overworked employees, reliability can be an issue.‍ Take, for example, chain pharmacies’ mishandling of the COVID-19 vaccine. Between January and March of 2021, pharmacies like CVS and Walgreens wasted nearly 180,000 doses of the vaccine due to poor planning.With numbers like this, patients should think critically about whether or not chains can offer them the specific care they need. Independent pharmacies, on the other hand, employ smaller staffs of experienced pharmacists and technicians. Because they have the extra time and resources that chains don’t, you can feel confident that independents will take the necessary steps to ensure your well-being.Whether it be filling a routine prescription or offering personal guidance and support, independents put in the time and effort to be there for you when you need them. ‍This is because reliability is at the heart of their business, as they look to form lasting relationships with patients rather than just make transactions.",
    dataaos: "slide-right",
  },
  {
    id: 2,
    img: img2,
    title: "Accuracy ",
    desc: "Compared to chain pharmacies, independents are less likely to make miscalculations, mix up prescriptions, or wrongly file patient information. As a result, when you choose an independent, you can be confident that you have access to closely-monitored, thoroughly-reviewed care.",
    dataaos: "slide-up",
  },
  {
    id: 3,
    img: img3,
    title: " Shorter Wait Times",
    desc: "When considering wait times, independent pharmacies come out on top.In effect, shorter wait times mean faster service and easier access to your pharmacist. Less time in line also means more time doing the things that you enjoy, with the health that you deserve ",
    dataaos: "slide-down",
  },
  {
    id: 4,
    img: img4,
    title: "Greater Convenience",
    desc: "Independent pharmacies are working to provide convenient care by offering modified services and pick-up options for patients. Because they are owned by individuals or families rather than large corporations, independents have the flexibility to coordinate when, where, and how their patients get the service they need. ‍For dispensing prescriptions, this can mean shipping medications and OTC products directly to patients’ homes or providing curbside and drive-through options; for vaccinations, it can mean setting up on-site clinics and scheduling patient appointments; for health consultations, it may refer to scheduling a meeting in-person or via a mobile tele-health service. Whichever way you choose to get it, independents’ variety of treatment and delivery options makes healthcare more convenient for you.",
    dataaos: "slide-up",
  },
  {
    id: 5,
    img: img5,
    title: "Enhanced Services",
    desc: "In addition to dispensing prescriptions, local independent pharmacies offer a variety of products and services including same-day home delivery, prescription compounding, preventive care (such as immunizations), medication therapy management, personalized weight loss programs, chronic disease management, medication synchronization, durable medical equipment, and most importantly, personalized care for you and your loved ones. ‍ Unlike their competitors, independent pharmacies aren’t focused solely on dispensing medications and making a sale. Rather, they are interested in providing clinical care that goes beyond prescriptions and makes a lasting impact on a patient’s health and quality of life.",
    dataaos: "slide-left",
  },
  {
    id: 6,
    img: img6,
    title: "More Affordable",
    desc: "Because chain pharmacies buy in bulk, it may seem that they are the more cost-efficient option. In reality, though, independent pharmacies are still cheaper than chains. While national chains continue to charge some of the highest out-of-pocket prices, independent pharmacies offer a variety of payment options and discount programs to make care accessible to everyone. If you are looking to spend less and save more, look to an independent.",
    dataaos: "slide-right",
  },
  {
    id: 7,
    img: img7,
    title: "Patient Education",
    desc: "Independent pharmacies care about educating their communities on health-related topics of all kinds. Whether it be teaching you how to properly use your medication, helping you navigate your illnesses, or working with you to create a plan to reach your health goals, pharmacists prioritize patient education. To facilitate this, some pharmacies offer online and in-person events, classes, and workshops. Others use social media to promote important information and keep you up-to-date with news and current events. Almost all can schedule you a one-on-one consultation with a pharmacist who can answer your questions, hear your concerns, and help get you on the path to wellness. ‍Independents understand that knowledge is power, and they are working to give you the knowledge you need to take control of your health and overall wellbeing.",
    dataaos: "slide-up",
  },
  {
    id: 8,
    img: img8,
    title: "Strong Relations ‍",
    desc: "Your local pharmacy knows that you’re more than just a number. As members of your community, they know your name, your face, and your unique health journey. This type of relationship may be why independents are statistically favored over chain pharmacies: because they know you as an individual, and not as a number or a dollar sign, they strive to give you the best care possible. As a patient, a stronger relationship with your pharmacist should give you the confidence to speak up and play an active role in your own health. ‍In addition to patients, local pharmacies also maintain strong relationships with nearby physicians, community leaders, and other service providers. Their network allows them to collaborate with other healthcare professionals, identify problems or gaps in care, and work together to solve them.",
    dataaos: "slide-down",
  },
  {
    id: 9,
    img: img9,
    title: "Sense of Community",
    desc: "Local pharmacies, pharmacists, and technicians are fully integrated into your community and your world. They understand your culture, share your values, and want to see your community succeed — in terms of physical health and beyond. Not only do independent pharmacies work within your community, but they are also actively involved in it. Just as independent pharmacies support your community, you should return the favor and support them. Not only does purchasing from an independent benefit the pharmacy directly, but it returns three times more revenue to the local economy than a dollar spent at a chain does. When you support an independent pharmacy, you support the success and invigoration of your own community. If you want to see meaningful change in your hometown, shop local and support independent pharmacies and businesses alike. ‍",
    dataaos: "slide-up",
  },
  {
    id: 10,
    img: img10,
    title: " Customer Satisfaction",
    desc: "From the speed and ease of shopping at local pharmacies, to the comprehensive care they provide, and the sense of community they build, there is no surprise that people still prefer “mom and pop” shops to big chains. ‍ Clearly, independent pharmacies are continuing to grow and see success as they offer personalized care in a fast-paced, ever-evolving healthcare",
    dataaos: "slide-left",
  },
];

const IVCP = () => {
  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <Container>
      <TopServiceBanner title=" IVCP " banner={banner} />
      <Inner>
        <Title>Show Your Local Pharmacy a Little Love</Title>
        <SubTitle>
          With chain pharmacies on almost every corner — whether it be a
          Walgreens, CVS, or any other national brand — it can be easy to
          overlook your local independent pharmacy. The prevalence of bigger
          chains may make it seem like they are the best (if not the only)
          option to get quality pharmacy care. ‍<br />
          <br />
          Tucked within your community, though, are independently-owned
          pharmacies that have the knowledge and expertise to get you the
          services you need — all from friendly faces in your community. When
          you need your next prescription filled, your next vaccine
          administered, or more personalized care that the big chains can’t
          offer you, think local.
          <br />
          <br />
          Here are the top 10 reasons to choose an independent pharmacy in your
          area: ‍
        </SubTitle>
        <Title>10 Reasons to Love Independent Pharmacy</Title>
        <CardContainer className="service__container">
          {ivcp.map((item) => (
            <div data-aos={item.dataaos} className="servicecard__container">
              <ImgContainer className="servicecard__image">
                <Img src={item.img} alt={item.title} />
              </ImgContainer>
              <div className="servicecard__info">
                <div className="servicecard__title">{item.title}</div>
                <span className="servicecard__id">{item.id}</span>
              </div>
              {/* <Desc className="servicecard__desc">{item.desc}</Desc> */}
            </div>
          ))}
        </CardContainer>
        <Title>Find a Pharmacy You'll Love</Title>
        <SubTitle>
          Don’t just claim your support of independents: go out and show them.
          Bring your business and support your community by consulting our
          Pharmacy Finder to find the best pharmacies near you that best fit
          your unique health needs. Shop small, shop local, and shop independent
          pharmacy. You’ll be glad you did.
        </SubTitle>
      </Inner>
      <BottomServiceBanner />
      <BottomBanner />
    </Container>

  );
};

export default IVCP;


const Container = styled.div``;
const Inner = styled.div``;

const SubTitle = styled.h2`
  font-size: 25px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;

const Img = styled.img`
  width: 50%;
  margin: 1rem;
`;

const ImgContainer = styled.div``;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
  padding: 1.5rem;

  &:hover p{
    opacity: 1;
  }
`;
